import React, {FC, ReactElement} from 'react';
import {Col, Row} from "antd";

import {GUTTER} from "../../../constants";
import {OrdersSummaryDataTableCard} from "../components/Investigation/OrdersSummaryDataTableCard";
import {MissedOrdersDataTableCard} from "../components/Investigation/MissedOrdersDataTableCard";
import {UnnecessaryOrdersDataTableCard} from "../components/Investigation/UnnecessaryOrdersDataTableCard";
import {FeedbackRowProps} from "./types";

export const InvestigationRow: FC<FeedbackRowProps> = ({attemptId, activityId, style}): ReactElement => (
    <Row gutter={GUTTER} style={style}>
        {attemptId && <Col xl={18} xs={24}>
            <OrdersSummaryDataTableCard attemptId={attemptId}/>
        </Col>}
        <Col xs={24} xl={12}>
            <MissedOrdersDataTableCard attemptId={attemptId} activityId={activityId}/>
        </Col>
        <Col xs={24} xl={12}>
            <UnnecessaryOrdersDataTableCard attemptId={attemptId} activityId={activityId}/>
        </Col>
    </Row>
);
